import { getField, updateField } from 'vuex-map-fields'
import getWorkflowTaskFiltersModel from './models/workflowTaskFilters'

const workflowTaskFilters = {
  namespaced: true,
  state: {
    ...getWorkflowTaskFiltersModel()
  },
  getters: {
    getField,
    getSearchObject (state) {
      return state
    }
  },
  actions: {
    clearFilters ({ commit }, userId) {
      return commit('clearFilters', userId)
    }
  },
  mutations: {
    updateField,
    clearFilters (state, userId) {
      state.workflowInstanceId = null
      state.assignedToUserId = userId || null
      state.statusId = null
      state.dueDateFrom = null
      state.dueDateTo = null
      state.clientId = null
      state.showCompleted = false
    }
  }
}

export default workflowTaskFilters
